<div class="modal common-right-modal benefit-modal " [class.show]="showAddEdit" id="addUserlist"
  aria-labelledby="exampleModalToggleLabel" tabindex="-1" style="display: block; padding-left: 0px;" aria-modal="true"
  role="dialog">
  <div class="modal-dialog modal-small">
    <div class="modal-content">
      <div class="modal-header upload-modal">
        <div class="title-head d-flex align-items-center">
          <button id="BtnCloseUploadDoc" type="button" class="btn-close tool-wrap position-relative"
            data-bs-dismiss="modal" (click)="closeAddEdit()" aria-label="Close">
            <div class="custom-tooltip tooltip-top" role="tooltip">
              <div class="arrow"></div>
              <div class="tooltip-inner"> Close </div>
            </div>
          </button>
          <h2 class="modal-title" id="exampleModalToggleLabel">
            <div class="d-flex align-items-center">
              {{isEdit?'Edit Role':'Add Role'}}
            </div>
          </h2>
        </div>
        <div class="btn-wrap">
          <button type="button" class="btn btn-outline-secondary" id="Upload-cancel-btn" (click)="closeAddEdit()"
            [disabled]="fetchingInProgress">Cancel</button>
          <button type="button" class="btn btn-primary" id="upload-save-btn" [disabled]="fetchingInProgress"
            (click)="saveRole()">Save</button>
        </div>
      </div>
      <div class="modal-body insurance-modal attach-doc upload-doc" [formGroup]="roleForm" *ngIf="!fetchingInProgress">
        <div class="row">
          <div class="col-6 mb-3">
            <div class="form-group">
              <label for="roleName" class="form-label">Role Name<span class="mandatory">*</span></label>
              <input type="text" appPreventFirstSpace autocomplete="off" class="form-control" id="Userfname"
                formControlName="roleName"
                [class.is-invalid]="formSubmitted && roleForm.controls['roleName'].errors?.['required']">
              <span *ngIf="formSubmitted && roleForm.controls['roleName']?.errors?.['required']"
                class="invalid-feedback d-block" tabindex="0">{{validationMsg}}</span>
            </div>
          </div>
          <div class="col-6 mb-3">
            <div class="form-group">
              <label class="form-label">User Type <span class="mandatory">*</span></label>
              <app-select-dropdown id="userType" [options]="userTypeList" label="userType" [placeholder]="'Select'"
                formControlName="userType"
                [class.is-invalid]="formSubmitted && roleForm.controls['userType'].errors?.['required']">
              </app-select-dropdown>
              <span *ngIf="formSubmitted && roleForm.controls?.['userType']?.errors?.['required']"
                class="invalid-feedback d-block" tabindex="0">{{validationMsg}}</span>
            </div>
          </div>
          <div class="col-6 mb-3">
            <div class="form-group">
              <label class="form-label">Status <span class="mandatory">*</span></label>
              <div class="radio-list  form-check-wrap">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="Status-active" formControlName="isActive"
                    [value]="1">
                  <label class="form-check-label" for="Status-active">Active</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="Status-inactive" formControlName="isActive"
                    [value]="2">
                  <label class="form-check-label" for="Status-inactive">Inactive</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inner-loader-wraper" *ngIf="fetchingInProgress">
        <div class="inner-loader"></div>
      </div>
    </div>
  </div>